import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import { useStyles } from "./styles";

type DescriptionProps = {
  icon?: string;
  title?: string;
  subtitle?: string;
};

const Description = ({ icon, subtitle, title }: DescriptionProps) => {
  const styles = useStyles();

  return (
    <section id="description">
      <Stack rowGap={4} alignItems="center" pt={5}>
        {icon && (
          <div
            test-id="image-logo-ds-marketing"
            className={styles.containerLogo}
          >
            <img className={styles.imageLogo} src={icon} alt="image-store" />
          </div>
        )}
        {title && (
          <Typography color="primary" variant="h5" fontWeight={500}>
            {title}
          </Typography>
        )}

        {subtitle && <Typography color="primary">{subtitle}</Typography>}
      </Stack>
    </section>
  );
};

export default Description;
